export namespace EAccount {
  export enum TagsType {
    USER = 'user',
  }
  export enum IdsType {
    CURRENT = 'current',
  }
}
